import styled from '@emotion/styled';
import LoadingIndicator from 'src/components/LoadingIndicator';
const EmptyListDesc = styled.div`
  position: relative;
  color: ${({
  theme
}) => theme.color.content12};
  font-size: 16px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  height: 301px;
  ${({
  theme
}) => theme.screenSize.mobile} {
    flex: 1;
  }
`;
const ShopLoading = () => <EmptyListDesc data-sentry-element="EmptyListDesc" data-sentry-component="ShopLoading" data-sentry-source-file="Loading.tsx">
    <LoadingIndicator size={25} data-testid='Shop-Loading' data-sentry-element="LoadingIndicator" data-sentry-source-file="Loading.tsx" />
  </EmptyListDesc>;
export default ShopLoading;